import React from 'react';
import type ServicedeskKnowledgeHubCategoryType from '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-category/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubCategory = lazyForPaint<
	typeof ServicedeskKnowledgeHubCategoryType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-knowledge-hub-category", jiraSpaEntry: "async-servicedesk-knowledge-hub-category" */ '@atlassian/jira-spa-apps-servicedesk-knowledge-hub-category'
		),
	),
);

const AsyncServicedeskKnowledgeHubCategory = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubCategory}
		pageId="spa-apps/servicedesk/knowledge-hub/category"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubCategory;
